<template>
  <div class="qq-container" :env="env">
    <div class="bg-title">重要指数</div>
    <div class="qq-wrap qq-table-wrap">
      <div class="qq-table-th">
        <span class="name">指数名称</span>
        <span class="price align-right">最新价</span>
        <span class="rate align-right">涨跌幅</span>
      </div>
      <div class="qq-table-content">
        <div class="qq-table-td" :class="getColor(item)" v-for="(item, index) in qqList" @click="gotoStock(item)" :key="index">
          <span class="name">{{item.name}}</span>
          <span class="price align-right">{{item.dyna.LastPrice | getPrice}}</span>
          <span class="rate align-right">{{getDifference(item) > 0 ? '+' : ''}}{{((getDifference(item)/item.statistic.PreClosePrice) * 100) | getPrice(2)}}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { ws } from '@/websocket'
import { request } from '@/api/request'
import { mapMutations, mapState } from 'vuex'
import config from '@/utils/chart/config'
let delayIndexSymbol = ['QQQ', 'DIA', 'SPY','.HSI','.HSCE','.HSCC']
export default {
  data () {
    return {
      env: process.env.NODE_ENV,
      qqList: [
        // {
        //     name: '上证指数',
        //     symbol: '000001',
        //     market: 'sh',
        //     isLink: true,
        // },
        // {
        //     name: '深证成指',
        //     symbol: '399001',
        //     market: 'sz',
        //     isLink: true,
        // },
        // {
        //     name: '创业板指',
        //     symbol: '399006',
        //     market: 'sz',
        //     isLink: true,
        // },
        {
          name: '恒生指数',
          symbol: '.HSI',
          market: 'HKIDX',
          isGo: true
        },
        {
          name: '国企指数',
          symbol: '.HSCE',
          market: 'HKIDX',
          isGo: true
        },
        {
          name: '红筹指数',
          symbol: '.HSCC',
          market: 'HKIDX',
          isGo: true
        },
        {
          name: '纳斯达克ETF',
          symbol: 'QQQ',
          market: 'NASDAQ',
          isGo: true
        },
        {
          name: '道琼斯ETF',
          symbol: 'DIA',
          market: 'AMEX',
          isGo: true
        },
        {
          name: '标普500ETF',
          symbol: 'SPY',
          market: 'AMEX',
          isGo: true
        },
        // {
        //   name: '日经225',
        //   symbol: 'N225',
        //   market: 'ASIDX'
        // },
        {
          name: '德国DAX',
          symbol: 'GDAXI',
          market: 'EUIDX'
        },
        {
          name: '英国富时100',
          symbol: 'FTSE',
          market: 'EUIDX'
        },
      ],
      iconSrc: {
        SH: require('@/assets/shicon.png'),
        SZ: require('@/assets/szicon.png')
      },
      dyna: {
        LastPrice: 0,
      },
      statistic: {
        PreClosePrice: 0
      }
    }
  },
  filters: {
    getPrice(val, fixed = 3) {
      return val !== undefined && !isNaN(val) && Number(val).toFixed(fixed) || '--'
    }
  },
  created () {
    this.qqList = this.qqList.map(item => ({
      ...item,
      dyna: this.dyna,
      statistic: this.statistic
    }))
    this.handleWSListeners('on')
    this.unsubscribeStockData()
    this.subscribeStockData()
  },
  beforeDestroy() {
    console.log('qq解绑')
    ws.websocket.removeListener('onSTATISTICS', this.cbStatisticsH,202)
    ws.websocket.removeListener('onDYNA', this.cbDynaH)
    this.unsubscribeStockData()
    clearInterval(this.rankInterval)
  },
  methods: {
    ...mapMutations(['setStatistics', 'setDyna', 'setSymbol']),
    handleWSListeners(key) {
      ws.websocket[key]('onSTATISTICS', this.cbStatisticsH,202)
      ws.websocket[key]('onDYNA', this.cbDynaH,202)
    },
    subscribeStockData() {
      this.unsubscribeStockData()
      for (let i = 0; i < this.qqList.length; i++) {
        let { symbol, market, name } = this.qqList[i]
        let tmpMarket = delayIndexSymbol.includes(symbol) ? 'DELAY_' + market: market
        // let tmpMarket = market
        ws.websocket.safeSubscribeSTATISTICS(symbol, tmpMarket,202)
        ws.websocket.safeUnsubscribeSTATISTICS(symbol, tmpMarket,202)
        ws.websocket.safeSubscribeDYNA(symbol, tmpMarket,202)
      }
    },
    unsubscribeStockData() {
      if (ws.websocket) {
        for (let i = 0; i < this.qqList.length; i++) {
          let { symbol, market } = this.qqList[i]
          // symbol = this.formatHKsymbol(this.qqList[i])
          let tmpMarket = delayIndexSymbol.includes(symbol) ? 'DELAY_' + market: market
          // let tmpMarket = market
          ws.websocket.safeUnsubscribeDYNA(symbol, tmpMarket)
          ws.websocket.safeUnsubscribeSTATISTICS(symbol, tmpMarket)
        }
      }
    },
    cbStatisticsH(data) {
      console.log('打印数据====data',data)
      if (data.QuoteData && data.QuoteData.StatisticsData) {
        let tmpMarket = data.Market.replace('DELAY_','')
        this.qqList.forEach(item => {
          const sc = `${item.market.toUpperCase()}${item.symbol}`
          if(sc == `${tmpMarket.toUpperCase()}${data.Inst}`) {
            item.statistic = data.QuoteData.StatisticsData[0] || {}
          }
        })
      }
    },
    cbDynaH(data) {
      // console.log(data, '======data')
      if (data.QuoteData && data.QuoteData.DynaData) {
        let tmpMarket = data.Market.replace('DELAY_','')
        this.qqList.forEach(item => {
          const sc = `${item.market.toUpperCase()}${item.symbol}`
          if(sc == `${tmpMarket.toUpperCase()}${data.Inst}`) {
            item.dyna = data.QuoteData.DynaData[0] || {}
          }
        })
      }
    },
    gotoStock(item) {
      const { market, symbol, isLink } = item
      if (!isLink) return
      const url = process.env.NODE_ENV === 'production' ? 'https://stock.9fzt.com/wap' : 'https://test-stock.9fzt.com/wap'
      window.location.href = `${url}/${market}/${symbol}.html`
    },
    getDifference(item) {
      const { dyna = {}, statistic = {} } = item
      const val = dyna.LastPrice || 0
      const base = statistic.PreClosePrice || 0
      let f = val - base
      return f
    },
    getColor(item) {
      const { dyna = {}, statistic = {} } = item
      const val = dyna.LastPrice || 0
      const base = statistic.PreClosePrice || 0
      let f = this.getDifference(item)
      if(f > 0) return 'rise-color'
      if(f < 0) return 'fall-color'
      return 'draw-color'
    },
  }
}
</script>

<style lang="stylus" scoped>
div
  box-sizing border-box
.bg-title
  height 36px
  padding 0 12px
  font-size 12px
  background #F5F5F5
  color #666
  line-height 36px
.align-right
  text-align right 
.rise-color
  color #E63535
  
.fall-color
  color #1BAA3C

.qq-table-wrap
  padding 8px 12px
  .qq-table-th
    display flex
    justify-content space-between
    height 30px
    line-height 30px
    font-size 13px
    color #999999
  .name
    display flex
    width 0
    flex 1
  .price
    width 100px
  .rate
    margin-left 50px
    width 80px
  .qq-table-td
    display flex
    justify-content space-between
    align-items center
    height 50px
    img
      width 15px
      height 10px
      margin-top 4px
      margin-right 2px
  .qq-table-td
    font-size 18px
    font-weight 500
    .name
      color #333
      font-size 16px

</style>